import React from 'react';

import useTEAORNumbers from 'hooks/teaor/useTEAORNumbers';

const ListOfTEAORNumbers: React.FC = () => {
    const { listOfTEAORNumbers, loading } = useTEAORNumbers('HU');

    if (loading) return null;

    return (
        <ul
            style={{
                listStyle: 'inside',
                paddingBlockStart: 6,
                paddingBlockEnd: 24,
            }}
        >
            {listOfTEAORNumbers?.map(({ teaor_number, teaor_text }) => (
                <li key={teaor_number}>
                    {teaor_number} - {teaor_text}
                </li>
            ))}
        </ul>
    );
};

export default ListOfTEAORNumbers;
